import CarrouselGroups from "../groups/carrouselGroups";
import "./matchesheader.sass";

export default function MatchesHeader({ TABS, groupId, standings, group, onSelectGroup, onSimulateGroup, groupsState = {} }) {

  const handleSimulateClick = () => {
    if (onSimulateGroup && group) {
      onSimulateGroup(groupId, group);
    }
  };

  return (
    <div className="MatchesHeaderContainer">
      <div className="MatchesHeader">
        <div className="MatchesHeaderLeft">
          <div className="MatchesTitle">PARTIDOS GRUPO {groupId}</div>
        </div>
        <div className="MatchesHeaderRight">
          <button className="btn-header-simulate" onClick={handleSimulateClick}><span>SIMULAR GRUPO</span></button>
        </div>
      </div>

      <CarrouselGroups
        TABS={TABS}
        activeGroup={groupId}
        onSelect={onSelectGroup}
        groupsState={groupsState} />
    </div>
  );
}